import { API_BASE_URL } from "../urls.api";

export const GET_NOISE_THRESHOLDS = `${API_BASE_URL}/noise-thresholds`;
